export const HOME = "/";
export const BROWSE_CLUBS = "/browse-clubs";
export const CREATE_CLUB = "/create-club";
export const CLUB_DETAILS = "/club-details";
export const OFFER = "/offer";
export const USER_ACCOUNT_SETTINGS = "/account-settings";
export const EMAIL_VERIFICATION = "/verification";
export const NOT_FOUND = "*";
export const DASHBOARD = "/dashboard";
export const MARKETPLACE = "/marketplace";
export const TYPE = "type";
export const PROJECT_FUNDRAISE = "project-fundraise";
